/* Motiv FAQ — sidebar scrollspy + search filter */
(function () {
  function initFaq(root) {
    const sidebarLinks = root.querySelectorAll('.motiv-faq__sidebar a');
    const categories = root.querySelectorAll('.motiv-faq__category');
    const items = root.querySelectorAll('.motiv-faq__item');
    const noResults = root.querySelector('.motiv-faq__no-results');
    const searchInput = document.querySelector('[data-faq-search]');

    /* Scrollspy — highlight the sidebar link for the section in view */
    if ('IntersectionObserver' in window && categories.length) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sidebarLinks.forEach(function (a) { a.classList.remove('is-active'); });
              const active = root.querySelector('.motiv-faq__sidebar a[href="#' + entry.target.id + '"]');
              if (active) active.classList.add('is-active');
            }
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      categories.forEach(function (cat) { observer.observe(cat); });
    }

    /* Smooth-scroll sidebar links */
    sidebarLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        const target = root.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* Search filter */
    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        const q = e.target.value.trim().toLowerCase();
        let visibleCount = 0;

        items.forEach(function (item) {
          const match = q === '' || item.textContent.toLowerCase().indexOf(q) !== -1;
          item.style.display = match ? '' : 'none';
          if (match) visibleCount++;
          if (q && match) {
            item.setAttribute('open', '');
          } else if (!q) {
            item.removeAttribute('open');
          }
        });

        categories.forEach(function (cat) {
          const anyVisible = Array.prototype.some.call(
            cat.querySelectorAll('.motiv-faq__item'),
            function (i) { return i.style.display !== 'none'; }
          );
          cat.style.display = q && !anyVisible ? 'none' : '';
        });

        if (noResults) noResults.classList.toggle('is-visible', q !== '' && visibleCount === 0);
      });
    }
  }

  document.querySelectorAll('.motiv-faq').forEach(initFaq);

  /* Re-init when edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('.motiv-faq');
    if (root) initFaq(root);
  });
})();
